<template>
  <div class="penthouse-detailed">
    <!-- Кнопка "вернуться" со стрелкой -->
    <div class="button-container">
      <router-link to="/penthouse-selection">
        <div class="button-back">
          <img src="/static/images/arrow_right.svg" alt="arrow" class="link-arrow__reverse" />
          <span>Вернуться</span>
        </div>
      </router-link>
    </div>

    <div class="container">
      <detailed-stats v-if="penthouseInfo" :content="penthouseInfo"></detailed-stats>
      <!-- Scheme -->
      <detailed-scheme
        class="penthouse-detailed__scheme"
        v-if="penthouseInfo"
        :content="penthouseInfo"
      ></detailed-scheme>
      <!-- Button mobile -->
      <!--      <div class="button-container center" v-if="isMobile">-->
      <!--        <router-link to="/penthouses">-->
      <!--          <div class="bordered-link">-->
      <!--            <span>Персональное предложение</span>-->
      <!--            <img src="/static/images/arrow_right.svg" alt="arrow" class="link-arrow">-->
      <!--          </div>-->
      <!--        </router-link>-->
      <!--      </div>-->
      <!-- Location -->
      <detailed-location :content="penthouseInfo"></detailed-location>
    </div>

    <div class="button-container" data-modal="#feedback-modal">
      <div class="bordered-link">
        <span>Персональное предложение</span>
        <div class="link-arrow__bg" />
      </div>
    </div>
  </div>
</template>

<script>
import DetailedLocation from "../components/DetailedLocation";
import DetailedScheme from "../components/DetailedScheme";
import DetailedStats from "../components/DetailedStats";
import { mapState } from "vuex";

export default {
  name: "PenthouseDetailed",
  components: {
    DetailedLocation,
    DetailedScheme,
    DetailedStats
  },
  computed: {
    ...mapState(["penthouseDetailed", "windowWidth", "statusesAndPrices"]),
    penthouseInfo() {
      return (
        this.penthouseDetailed.content &&
        this.penthouseDetailed.content.detailed
      );
    },
    isMobile() {
      return this.windowWidth < 1000;
    }
  },
  beforeCreate() {
    this.$store.dispatch("getPenthouseDetailed", this.$route.params.pentNumber);
    this.$store.dispatch("getStatusesAndPrices");
    document.body.classList.add("_burger-white");
    document.body.classList.remove("_white-bg");
  },
  beforeDestroy() {
    document.body.classList.remove("_burger-white");
  },
  mounted() {
    document.body.classList.remove("__penthouse-selection");
  }
};
</script>

<style scoped lang="stylus">
@import '../styles/tools';

.penthouse-detailed {
  width: 100vw;
  min-height: 100vh;
  padding-top: 140px;
  padding-left: 130px;
  padding-right: 130px;
  padding-bottom: 100px;
  width-between-property: 'padding-left' 1000 15 1920 100 true true;
  width-between-property: 'padding-right' 1000 15 1920 130 true true;
  background: $backgroundBlue;
  display: flex;
  flex-direction: column;
  // justify-content space-between
  align-items: center;

  @media (max-width: 1000px) {
    padding: 100px 20px;
  }

  &__scheme {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    padding-left: 30px;
    padding-right: 30px;

    @media (min-width: 1000px) {
      width-between-property: 'width' 1000 340 1920 810 false true;
      margin-left -125px
    }

    @media (max-width: 1000px) {
      margin: 30px auto;
      padding-left: 10px;
      padding-right: 10px;
    }

    @media (min-width: 601px) and (max-width: 999px) {
      width-between-property: 'width' 601 470 999 770 false true;
    }

    @media (max-width: 600px) {
      width-between-property: 'width' 320 260 600 470 true true;
    }
  }
}

.container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 5px;

  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.button-container {
  display: flex;
  width: 100%;
  margin: 20px 0 70px 0;

  @media (max-width: 1000px) {
    margin: 35px 0 30px 0;
  }
}

.bordered-link {
  font-family: 'Asket Extended';
  width-between-property: 'font-size' 320 8 1000 14 true true;
  text-transform: uppercase;
  padding: 15px 30px 12px;
  border: 1px solid $white;
  border-radius: 100px;
  color: $white;
  display: flex;
  cursor pointer
  transition all ease-in-out 0.3s
  justify-content: center;
  align-items: center;
  &:hover {
    color $backgroundBlue
    border 1px solid $backgroundBlue
    background-color $white
    & .link-arrow__bg {
      background-image url('../static/images/arrow_right-blue.svg')
    }
  }
  @media (min-width: 1000px) {
    font-size: 14px;
  }
}

.link-arrow {
  padding-left: 15px;
  margin-top: -3px;

  &__reverse {
    width: 55px;
    height: 7px;
    transform: rotatey(180deg);
    object-fit: cover;
    margin-right: 15px;
    margin-top: 2px;
  }

  &__bg {
    background-image url('../static/images/arrow_right.svg')
    margin-left 15px
    background-size cover
    background-repeat no-repeat
    background-position center
    width 30px
    height 10px
  }
}

.button-back {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  opacity: 0.8;
  color: $white;
  display: flex;
  width: 100%;
}

.center {
  justify-content: center;
}

.detailed-location {
  @media (max-width: 1000px) {
    margin: 10px auto;
  }
}
</style>